import Authority from "@/enum/Authority";
import ShopType from "@/enum/ShopType";
import { createShop, syncShopSubscription } from "@/services/api/shop";
import { useGlobalStore } from "@/store/hooks";
import { useRequest } from "ahooks";
import { Modal } from "antd";
import React, { useEffect, useRef } from "react";
import { useHistory } from "react-router";
import OrderTab from "../../enum/OrderTab";

interface CreateManualShopButtonProps {}

const CreateManualShopButton: React.FC<CreateManualShopButtonProps> = function (props) {
    const globalStore = useGlobalStore();
    const { allowedShops, loadShopList, companyRoleStore } = globalStore;
    const history = useHistory();
    const modalRef = useRef<ReturnType<typeof Modal.confirm>>();

    const { loading, runAsync } = useRequest(createShop, { manual: true });

    function handleCreateManualShop(e) {
        e?.stopPropagation?.();

        const shouldNext = globalStore.checkUserAuthority(Authority.ROLE_SHOP_MANAGEMENT);

        if (!shouldNext) {
            return;
        }

        modalRef.current = Modal.confirm({
            title: "创建手工店铺",
            content:
                "通过手工店铺，你可以手动添加或通过表格批量导入线下订单打印，你当前还没有手工店铺，需要现在创建一个吗",
            onOk: async () => {
                const shop = await runAsync("手工店铺", ShopType.MANUAL);

                await syncShopSubscription(shop.id);

                await loadShopList();

                history.push(`/order/list?shopId=${shop.id}&tab=${OrderTab.PENDING_SHIPMENT}`);
            },
        });
    }

    useEffect(() => {
        if (loading) {
            modalRef.current?.update({ okButtonProps: { loading } });
        }
    }, [loading]);

    const hasManual = allowedShops.some((shop) => shop.type === ShopType.MANUAL);

    if (hasManual || companyRoleStore.isPureSupplier) return null;

    return (
        <a href="#" className="nav-link" onClick={handleCreateManualShop}>
            <span>自由打印</span>
            <span className="text-muted small">(手工店铺)</span>
        </a>
    );
};

export default React.memo(CreateManualShopButton);
